// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 438) return "content/plugin-product-frac-ui/da24844aaea1e11aedfd81e26a9db187.js";
	if (chunkId === 608) return "content/plugin-product-frac-ui/f69d7579d599bbcbdc274c13c07cefc6.js";
	// return url for filenames based on template
	return undefined;
};